"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var PromotionPerformanceExportRowExtension_1 = require("../model/PromotionPerformanceExportRowExtension");

var PromotionPerformanceReportDataConverterImpl_1 = require("../promoperf/conversions/PromotionPerformanceReportDataConverterImpl");

var PromotionPerformanceExportRowExtensionConverter_1 = require("./PromotionPerformanceExportRowExtensionConverter");

var PromotionPerformanceExportRowExtensionConverterImpl =
/*#__PURE__*/
function (_PromotionPerformance) {
  _inherits(PromotionPerformanceExportRowExtensionConverterImpl, _PromotionPerformance);

  function PromotionPerformanceExportRowExtensionConverterImpl(perfPromotionConverter, perfWindowConverter) {
    var _this;

    _classCallCheck(this, PromotionPerformanceExportRowExtensionConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromotionPerformanceExportRowExtensionConverterImpl).call(this));
    _this.perfPromotionConverter = perfPromotionConverter;
    _this.perfWindowConverter = perfWindowConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(PromotionPerformanceExportRowExtensionConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new PromotionPerformanceExportRowExtension_1.PromotionPerformanceExportRowExtension(this.perfPromotionConverter.toObject(source.promotion, conversions), PromotionPerformanceExportRowExtension_1.PromotionPerformanceExportRowExtension.schema.promotionGosExtId.valueOfField(source), PromotionPerformanceExportRowExtension_1.PromotionPerformanceExportRowExtension.schema.promotionTypeName.valueOfField(source), this.perfWindowConverter.toObject(source.window, conversions), PromotionPerformanceExportRowExtension_1.PromotionPerformanceExportRowExtension.schema.windowTypeName.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        promotion: this.perfPromotionConverter.toDocument(source.promotion, conversions),
        promotionGosExtId: source.promotionGosExtId,
        promotionTypeName: source.promotionTypeName,
        window: this.perfWindowConverter.toDocument(source.window, conversions),
        windowTypeName: source.windowTypeName
      });
      return result;
    }
  }]);

  return PromotionPerformanceExportRowExtensionConverterImpl;
}(PromotionPerformanceExportRowExtensionConverter_1.PromotionPerformanceExportRowExtensionConverter);

PromotionPerformanceExportRowExtensionConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __metadata("design:paramtypes", [PromotionPerformanceReportDataConverterImpl_1.PerfPromotionConverter, PromotionPerformanceReportDataConverterImpl_1.PerfWindowConverter])], PromotionPerformanceExportRowExtensionConverterImpl);
exports.PromotionPerformanceExportRowExtensionConverterImpl = PromotionPerformanceExportRowExtensionConverterImpl;